// extracted by mini-css-extract-plugin
export default {"flex":"bill-product-list_flex__YccUQ","text_center":"bill-product-list_text_center__YqmUQ","table":"bill-product-list_table__tq9Z-","td":"bill-product-list_td__tent-"};